<template>
  <div>
    <component :is="pageView" @change-page="changePage" v-bind="$attrs" />
  </div>
</template>

<script setup>
import home from './home';
import invoicing from './invoicing';
import openEnd from './openEnd';

const pageView = shallowRef(home);

function changePage(page) {
  switch (page) {
    case 'blueInvoice_home':
      pageView.value = home;
      break;
    case 'blueInvoice_invoicing':
      pageView.value = invoicing;
      break;
    case 'blueInvoice_openEnd':
      pageView.value = openEnd;
      break;
  }
}
</script>

<style lang="scss" scoped></style>
